/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WebhookDeliveryResponse } from '../models/WebhookDeliveryResponse';
import type { WebhookSubscriptionCreate } from '../models/WebhookSubscriptionCreate';
import type { WebhookSubscriptionResponse } from '../models/WebhookSubscriptionResponse';
import type { WebhookSubscriptionUpdate } from '../models/WebhookSubscriptionUpdate';
import type { WebhookTestResult } from '../models/WebhookTestResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CampaignWebhooksService {
    /**
     * List Webhooks
     * @param campaignId
     * @returns WebhookSubscriptionResponse Successful Response
     * @throws ApiError
     */
    public static listWebhooksApiCampaignsCampaignIdWebhooksGet(
        campaignId: string,
    ): CancelablePromise<Array<WebhookSubscriptionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/webhooks',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Webhook
     * @param campaignId
     * @param requestBody
     * @returns WebhookSubscriptionResponse Successful Response
     * @throws ApiError
     */
    public static createWebhookApiCampaignsCampaignIdWebhooksPost(
        campaignId: string,
        requestBody: WebhookSubscriptionCreate,
    ): CancelablePromise<WebhookSubscriptionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/webhooks',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Webhook
     * @param campaignId
     * @param subscriptionId
     * @returns WebhookSubscriptionResponse Successful Response
     * @throws ApiError
     */
    public static getWebhookApiCampaignsCampaignIdWebhooksSubscriptionIdGet(
        campaignId: string,
        subscriptionId: string,
    ): CancelablePromise<WebhookSubscriptionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/webhooks/{subscription_id}',
            path: {
                'campaign_id': campaignId,
                'subscription_id': subscriptionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Webhook
     * @param campaignId
     * @param subscriptionId
     * @param requestBody
     * @returns WebhookSubscriptionResponse Successful Response
     * @throws ApiError
     */
    public static updateWebhookApiCampaignsCampaignIdWebhooksSubscriptionIdPatch(
        campaignId: string,
        subscriptionId: string,
        requestBody: WebhookSubscriptionUpdate,
    ): CancelablePromise<WebhookSubscriptionResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/campaigns/{campaign_id}/webhooks/{subscription_id}',
            path: {
                'campaign_id': campaignId,
                'subscription_id': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Webhook
     * @param campaignId
     * @param subscriptionId
     * @returns void
     * @throws ApiError
     */
    public static deleteWebhookApiCampaignsCampaignIdWebhooksSubscriptionIdDelete(
        campaignId: string,
        subscriptionId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/campaigns/{campaign_id}/webhooks/{subscription_id}',
            path: {
                'campaign_id': campaignId,
                'subscription_id': subscriptionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Test Webhook
     * @param campaignId
     * @param subscriptionId
     * @returns WebhookTestResult Successful Response
     * @throws ApiError
     */
    public static testWebhookApiCampaignsCampaignIdWebhooksSubscriptionIdTestPost(
        campaignId: string,
        subscriptionId: string,
    ): CancelablePromise<WebhookTestResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/webhooks/{subscription_id}/test',
            path: {
                'campaign_id': campaignId,
                'subscription_id': subscriptionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Deliveries
     * @param campaignId
     * @param subscriptionId
     * @param limit
     * @param offset
     * @returns WebhookDeliveryResponse Successful Response
     * @throws ApiError
     */
    public static listDeliveriesApiCampaignsCampaignIdWebhooksSubscriptionIdDeliveriesGet(
        campaignId: string,
        subscriptionId: string,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<Array<WebhookDeliveryResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/webhooks/{subscription_id}/deliveries',
            path: {
                'campaign_id': campaignId,
                'subscription_id': subscriptionId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Replay Delivery
     * @param campaignId
     * @param subscriptionId
     * @param deliveryId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static replayDeliveryApiCampaignsCampaignIdWebhooksSubscriptionIdDeliveriesDeliveryIdReplayPost(
        campaignId: string,
        subscriptionId: string,
        deliveryId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/webhooks/{subscription_id}/deliveries/{delivery_id}/replay',
            path: {
                'campaign_id': campaignId,
                'subscription_id': subscriptionId,
                'delivery_id': deliveryId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
